import {API_HOST, AXIOS_INSTANCE, catchError} from './api'

const LIST_KITS = "kits";
const ASSOCIATE_KIT = "associate-kit";
const VALIDATE_KIT = "associate-kit/validate";
const KIT_ANSWERS = "last";
const KIT_LAST_ANSWERS = "last";

export async function LIST_KIT(id) {
  try {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${LIST_KITS}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (e) {
    catchError(e);
  }
}

export function POST_KIT(form) {
  return AXIOS_INSTANCE.post(`${API_HOST}/${ASSOCIATE_KIT}`, form, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  }).catch(err => catchError(err));
}

export function POST_KIT_VALIDATE(form) {
  return AXIOS_INSTANCE.post(`${API_HOST}/${VALIDATE_KIT}`, form, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
}

export async function GET_KIT_ANSWERS(kit_id) {
  try {
    const response = await AXIOS_INSTANCE.get(`${API_HOST}/${LIST_KITS}/${kit_id}`, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem('token')
      }
    });
    return response.data;
  } catch (e) {
    catchError(e);
  }
}

export function LAST_ANSWERS() {
  return AXIOS_INSTANCE.get(`${API_HOST}/${LIST_KITS}/${KIT_LAST_ANSWERS}`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('token')
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/kit.js